import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Icon from '../Icon2';
import './Carousel.css'
import { iconName } from '../Icon2/constants';

const CarouselComponent = (props) => {

  const { carouselContainer, carouselItemContainer, outerContainer, handlePrev, handleNext, onBeforeDragStart, onDragEnd, carouselItems } = props;

  return (
    <div
      data-test-id={props.testId}
      ref={outerContainer}
      className={`Carousel ${props.version === 'v2' ? 'Carousel__v2' : ''} ${props.type === 'card' ? 'Carousel--card' : ''} ${props.dynamicWidth ? 'DynamicCarousel' : ''}`}>
      <div ref={carouselContainer}>
        <>
          <button
            id="button-prev"
            aria-label="Previous Button"
            className={`Carousel__slide-button Carousel__slide-button--prev`}
            onClick={handlePrev}
            type="button">
            <Icon icon={iconName.LeftArrow} className="Carousel__slide-icon" />
          </button>
          <button
            id="button-next"
            aria-label="Next Button"
            className={`Carousel__slide-button Carousel__slide-button--next`}
            onClick={handleNext}
            type="button">
            <Icon icon={iconName.RightArrow} className="Carousel__slide-icon" />
          </button>
        </>
        <DragDropContext onBeforeDragStart={onBeforeDragStart} onDragEnd={onDragEnd}>
          <div ref={carouselItemContainer} className="Carousel__wrapper">
            <Droppable isDropDisabled={false} droppableId="carousel-droppable" direction="horizontal">
              {(provided: any, snapshot: any) => (
                <div {...provided.placeholder} {...provided.droppableProps} ref={provided.innerRef}>
                  {carouselItems.map((item: any, index: any) => {
                    return (
                      <div className="Carousel__item" key={index}>
                        <Draggable
                          isDragDisabled={props.disableDragDrop}
                          key={item.id}
                          draggableId={item.id}
                          index={index}>
                          {(provided: any, snapshot: any) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...(props.showDragIcon ? null : provided.dragHandleProps)}>
                              {props.showDragIcon ? (
                                <>
                                  {item.component}
                                  <div className="Carousel__item--drag" {...provided.dragHandleProps}>
                                    {props.version === 'v2' ?
                                      <Icon icon="ActionBar" className='ml-8' version='v2' height={20} width={20} />
                                      :
                                      <Icon icon="MoveIcon" />
                                    }
                                  </div>
                                </>
                              ) : (
                                item.component
                              )}
                            </div>
                          )}
                        </Draggable>
                      </div>
                    )
                  })}
                </div>
              )}
            </Droppable>
          </div>
        </DragDropContext>
      </div>
    </div>
  )
}

export default CarouselComponent;